import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CONSTANT } from "src/app/constant";
import { ReportSummaryComment } from "src/app/models/models";
import { HelperService } from "src/app/util/helper.service";

export interface SummaryCommentDisplay {
	candidateRole?: string | null;
	maneuver: string;
	ob: string;
	action: boolean | null;
	instructorComment: string;
	isDisabled: boolean;
	isReset?: boolean;
	lastActionDisabled?: boolean;
	rate?: number;
	remarks?: string;
}

@Component({
	selector: "app-cbta-rating-summary-comments",
	templateUrl: "./cbta-rating-summary-comments.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaRatingSummaryCommentsComponent {
	@Input() set comments(value: ReportSummaryComment[]) {
		this._comments = this.helperService.filterReportSummaryComments(value ?? []);
	}

	get comments(): ReportSummaryComment[] {
		return this._comments;
	}

	@Input() uppercase = false;

	CANDIDATE_ROLE = CONSTANT.CANDIDATE_ROLE;

	private _comments: ReportSummaryComment[] = [];

	constructor(private helperService: HelperService) {}

	toDisplayComment(comment: ReportSummaryComment): SummaryCommentDisplay {
		return this.helperService.toSummaryDisplayComment(comment);
	}
}
